import React, { useState } from 'react';
import { certificates, users } from '../mock/certificates';
import CertificateCard from '../components/CertificateCard';

const CertificatesPage = () => {
  const [currentUser] = useState(users[0]); // Simulamos usuario logueado
  const userCertificates = certificates.filter(cert => cert.userId === currentUser.id);

  return (
    <div className="ml-64 p-6">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-800">Certificados de {currentUser.name}</h1>
        <p className="text-gray-600">Logros y reconocimientos de tu Mascohijo</p>
      </div>

      {userCertificates.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {userCertificates.map(certificate => (
            <CertificateCard 
              key={certificate.id} 
              certificate={certificate} 
            />
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm p-8 text-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 className="text-lg font-medium text-gray-800 mt-4">Aún no hay certificados</h3>
          <p className="text-gray-500 mt-1">Tu mascota aún no ha obtenido certificados</p>
        </div>
      )}
    </div>
  );
};

export default CertificatesPage;